import { Fragment } from 'preact';
import { Text } from 'preact-i18n';
import DatesControls from '../../DatePicker/components/DatesControls';
import { selectIcon } from '../../../templates/place';

const DateTriggerRow = ({
  error,
  showCompact,
  locale,
  handleCompactDateClick,
  handleQuickDate,
  handleMundialClick,
  showMundialButton,
  showTomorrowWithMundial,
  showQuickDates,
  departureDate,
  returnDate,
  openTicketText,
  openTicketLabel,
  departurePlaceholder,
  returnPlaceholder,
  handleInputClick,
  handleCleanDeparture,
}) => (
  <div className="udp-trigger-row__slot">
    {showCompact && (
      <div className="udp-compact-dates-controls">
        <DatesControls
          label={<Text id="label.when_traveling" />}
          locale={locale}
          onDateClick={handleCompactDateClick}
          onTodayClick={() => handleQuickDate(0)}
          onTomorrowClick={() => handleQuickDate(1)}
          onMundialClick={handleMundialClick}
          showMundialButton={showMundialButton}
          showTomorrowWithMundial={showTomorrowWithMundial}
          showQuickDates={showQuickDates}
        />
      </div>
    )}

    {!showCompact && (
      <Fragment>
        <div
          className={`departureDate-wrapper${error ? ' field-error' : ''}`}
          onClick={() => handleInputClick(false)}
        >
          <label className={`label label-dates${error ? ' label-error' : ''}`}>
            <Text id="label.departure_date" />
          </label>

          <input
            type="text"
            readOnly
            className="udp-display-input"
            value={(departureDate === openTicketText ? openTicketLabel : departureDate) || ''}
            placeholder={departurePlaceholder}
          />
        </div>

        {/*
         * Both fields stay mounted so the row reads the same before and after a date is picked.
         * Today the compact controls cover the empty state, but that has broken silently before:
         * when blocked dates briefly hid them, this branch rendered with no value, no placeholder
         * and no return field. Keeping both fields self-sufficient means no future change to
         * showCompact can expose a blank trigger again.
         */}
        <div className="returnDate-wrapper" onClick={() => handleInputClick(true)}>
          <label className="label label-dates">
            <Text id="label.return_date" />
          </label>

          <input
            type="text"
            readOnly
            className="udp-display-input"
            value={(returnDate === openTicketText ? openTicketLabel : returnDate) || ''}
            placeholder={returnPlaceholder}
          />
        </div>

        {(departureDate || returnDate) && (
          <div
            className="clean-place-input udp-clear-btn"
            onClick={handleCleanDeparture}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: selectIcon('cleanIcon', false) }}
          />
        )}

        {!departureDate && !returnDate && (
          <div
            className="iqdropdown-selection"
            onClick={() => handleInputClick(false)}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: selectIcon('arrow', false) }}
          />
        )}
      </Fragment>
    )}
  </div>
);

export default DateTriggerRow;
